(() => {
  const sticky = document.querySelector('[data-vv-sticky-atc]');
  if (!sticky) return;

  const sectionId = sticky.dataset.sectionId;
  const trigger = sticky.querySelector('[data-vv-sticky-trigger]');
  const stickyPrice = sticky.querySelector('[data-vv-sticky-price]');
  const getProductInfo = () => document.getElementById(`ProductInfo-${sectionId}`);
  const getSubmit = () => document.getElementById(`ProductSubmitButton-${sectionId}`);

  const sync = () => {
    const submit = getSubmit();
    const price = document.querySelector(`#price-${sectionId} .price-item--sale`) || document.querySelector(`#price-${sectionId} .price-item--regular`);
    if (!submit) return;
    trigger.disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
    const buttonText = submit.querySelector('span')?.textContent?.trim();
    const priceText = price?.textContent?.trim();
    if (buttonText && trigger.textContent.trim() !== buttonText) trigger.textContent = buttonText;
    if (priceText && stickyPrice && stickyPrice.textContent.trim() !== priceText) stickyPrice.textContent = priceText;
  };

  const updateVisibility = () => {
    const submit = getSubmit();
    if (!submit || window.innerWidth >= 750) {
      sticky.classList.remove('is-visible');
      sticky.setAttribute('aria-hidden', 'true');
      return;
    }
    const rect = submit.getBoundingClientRect();
    const isPastPrimaryCta = rect.bottom < 0;
    sticky.classList.toggle('is-visible', isPastPrimaryCta);
    sticky.setAttribute('aria-hidden', isPastPrimaryCta ? 'false' : 'true');
    sync();
  };

  trigger.addEventListener('click', () => getSubmit()?.click());
  document.querySelectorAll('[data-vv-repeat-atc]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const submit = getSubmit();
      if (!submit) return;
      event.preventDefault();
      submit.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
  const unsubscribeVariantChange =
    typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange
      ? subscribe(PUB_SUB_EVENTS.variantChange, sync)
      : null;
  window.addEventListener('scroll', updateVisibility, { passive: true });
  window.addEventListener('resize', updateVisibility, { passive: true });
  window.addEventListener('pagehide', () => unsubscribeVariantChange?.(), { once: true });
  sync();
  updateVisibility();
})();
